import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { FaPencilAlt, FaTimes, FaMapMarkerAlt, FaCheck, FaUndo } from "react-icons/fa";
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import './TaskDetail.css';
import '../../../components/PageHeader/PageHeader.css';
import PageHeader from '../../../components/PageHeader/PageHeader';
import { useI18n } from '../../../i18n';
import { API, Auth } from 'aws-amplify';
import { useToasts } from 'react-toast-notifications';

import TaskInfo from './TaskInfo/TaskInfo';
import TaskLog from './TaskLog/TaskLog';
import TaskPDF from './TaskPDF';

const ALL_OK_RI = {
    q1_lamps: { ok: true },
    q2_signal_heads: { ok: true },
    q3_caps_bungs: { ok: true },
    q4_push_buttons: { ok: true },
    q5_controller: { ok: true },
    q6_detection: { ok: true },
    q7_log_book: { ok: true },
    q8_site_issues: { ok: true },
    q9_door: { ok: true },
};

const TaskDetail = (props) => {
    const { t, tStatus } = useI18n();
	const [taskDet, setTaskDet] = useState([]);
	const [assetDet, setAssetDet] = useState([]);
	const [loadedTaskDet, setLoadedTaskDet] = useState(false);
    const [usersDet, setUsersDet] = useState([]);
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [showWipModal, setShowWipModal] = useState(false);
    const [wipReason, setWipReason] = useState('');
    const handleCloseWipModal = () => {
        setShowWipModal(false);
        setWipReason('');
    };
    const handleShowWipModal = () => setShowWipModal(true);
    const [showCompleteModal, setShowCompleteModal] = useState(false);
    const [completeWorkDone, setCompleteWorkDone] = useState('');
    const [completing, setCompleting] = useState(false);
    const handleCloseCompleteModal = () => {
        setShowCompleteModal(false);
        setCompleteWorkDone('');
    };
    const handleShowCompleteModal = () => {
        setCompleteWorkDone('closed by Admin');
        setShowCompleteModal(true);
    };
    const { addToast } = useToasts();
    const isAdmin = props.user && props.user.administrator === 'true';
    const isActiveTask = taskDet && taskDet.task_status && taskDet.task_status !== 'Completed';

    const headers = {
        'x-api-key': (typeof process !== 'undefined' && process.env && process.env.REACT_APP_API_KEY) || '',        
        'Accept': 'application/json',
        'Content-Type': 'application/json',
    };

    const params = { headers }

    // Fetch task and asset
    useEffect(()=>{
        if (props.match.params.id){
            API.get('task_active','/' + props.match.params.id, params)
            .then(task => {
                setTaskDet(task)
                setLoadedTaskDet(true)
                if (task.assetId){
                    API.get('assets','/' + task.assetId, params)
                    .then(res => {
                        // console.log(asset)
                        if (res.hp_site===true) {
                            res.hp_site_str = "High"
                        }else{
                            res.hp_site_str = "Low"
                        }
                        setAssetDet(res);
                    });
                }
            })
            .catch((err) => {
                addToast(t('toast.errorLoadingTask'), { appearance: 'error' });
            });
        }
    }, []);

    // Fetch users
    useEffect(()=>{
        API.get('users','/', params)
        .then(res => {
            let userList = []; 
            res.Users.forEach((item) => {
                let user = {}
                user.id = item.Username;
                item.Attributes.forEach((e) => {
                    if (e.Name === 'name')
                        user.name = e.Value;
                }) 
                userList.push(user);
            })
            setUsersDet(userList);
        })
    },[])

    const handleShowMoveToWip = () => {
        if (!taskDet || !taskDet.taskId || !taskDet.assetId) {
            addToast(t('toast.taskNotLoaded'), { appearance: 'error' });
            return;
        }
        if (taskDet.task_status !== 'Completed') {
            addToast(t('toast.onlyCompletedToWip'), { appearance: 'warning' });
            return;
        }
        handleShowWipModal();
    }

    const handleMoveToWip = async () => {
        if (!wipReason || wipReason.trim() === '') {
            addToast(t('toast.wipReasonRequired'), { appearance: 'warning' });
            return;
        }

        handleCloseWipModal();

        try {
            // Get current authenticated user from web
            const currentUser = await Auth.currentAuthenticatedUser();
            const userId = currentUser.username;

            API.post('move_completed_to_wip', '/' + taskDet.taskId, {
                body: {
                    reason: wipReason.trim(),
                    userId,
                    assetId: taskDet.assetId,
                },
                headers,
            })
            .then(() => {
                addToast(t('toast.taskMovedToWip'), { appearance: 'success' });
                setTaskDet({ ...taskDet, task_status: 'WIP' });
            })
            .catch((err) => {
                console.log(err);
                addToast(t('toast.errorMovingToWip'), { appearance: 'error' });
            });
        } catch (authErr) {
            console.log('Error getting current user:', authErr);
            addToast(t('toast.noCurrentUser'), { appearance: 'error' });
        }
    }

    const handleShowMoveToCompleted = () => {
        if (!isAdmin) {
            addToast(t('toast.onlyAdminsComplete'), { appearance: 'warning' });
            return;
        }
        if (!taskDet || !taskDet.taskId || !taskDet.assetId) {
            addToast(t('toast.taskNotLoaded'), { appearance: 'error' });
            return;
        }
        if (!isActiveTask) {
            addToast(t('toast.onlyActiveToCompleted'), { appearance: 'warning' });
            return;
        }
        handleShowCompleteModal();
    }

    const handleMoveToCompleted = async () => {
        if (!completeWorkDone || completeWorkDone.trim() === '') {
            addToast(t('toast.workDoneRequired'), { appearance: 'warning' });
            return;
        }

        setCompleting(true);
        try {
            const currentUser = await Auth.currentAuthenticatedUser();
            const userId = currentUser.username;

            await API.post('complete_task', '/' + taskDet.taskId, {
                body: {
                    qr_scan_end: false,
                    userId,
                    assetId: taskDet.assetId,
                    taskId: taskDet.taskId,
                    wd_desc: completeWorkDone.trim(),
                    materials_description: '-',
                    ri: ALL_OK_RI,
                },
                headers,
            });

            handleCloseCompleteModal();
            addToast(t('toast.taskMovedToCompleted'), { appearance: 'success' });
            props.history.push('/tasks_comp');
        } catch (err) {
            console.log(err);
            addToast(t('toast.errorMovingToCompleted'), { appearance: 'error' });
        } finally {
            setCompleting(false);
        }
    }

    const handleDelete = (taskId) => {
        // alert('delete ' + taskId)
        setShow(false);
        API.put('task_active', '/' + taskId, {      
            body: {
                paramName: 'task_active',
                paramValue: false
            },
            headers: headers,
        })
        .then(res => {
            // console.log(res)
            // delete task log
            API.post('del_task_log', '/' + res.assetId, {      
                body: {
                    taskId: taskId
                },
                headers: headers,
            })
            .then(response => { 
                console.log(response);
            }).catch(error => {
                console.log(error)
                addToast(t('toast.errorDeletingTaskLog'), { appearance: 'error' });
            });

            addToast(t('toast.taskDeleted'), { appearance: 'success' });
            props.history.push('/tasks');           
        }).catch(error => {
            console.log(error)
            addToast(t('toast.errorDeletingTask'), { appearance: 'error' });
        });
    }

        const statusClassMap = {
            'Created': 'status-created',
            'Accepted': 'status-accepted',
            'Started': 'status-started',
            'Completed': 'status-completed',
            'WIP': 'status-wip',
        };
        const statusClass = statusClassMap[taskDet && taskDet.task_status] || 'status-created';

        return (
            <div className="TaskDetail">
                <PageHeader
                    title={
                        <>
                            <h1 className="header-title">{t('pages.taskDetails.title')}</h1>
                            {taskDet && taskDet.task_ref && (
                                <span className="task-ref-mark">#{taskDet.task_ref}</span>
                            )}
                        </>
                    }
                    pageTitle={taskDet && taskDet.task_ref ? t('pages.taskDetails.pageTitle', { ref: taskDet.task_ref }) : t('pages.taskDetails.title')}
                    breadcrumbs={[
                        { label: t('nav.tasks'), path: '/tasks' },
                        { label: taskDet?.task_ref || t('common.details') },
                    ]}
                    backTo="/tasks"
                    backLabel={t('nav.tasks')}
                    statusBadge={taskDet && taskDet.task_status && (
                        <span className={`status-badge ${statusClass}`}>{tStatus(taskDet.task_status)}</span>
                    )}
                    subtitle={
                        (assetDet && assetDet.site_ref) || (taskDet && taskDet.category_str) ? (
                            <span className="subtitle-item">
                                {assetDet && assetDet.site_ref ? (
                                    <>
                                        <FaMapMarkerAlt /> {assetDet.site_ref}
                                        {assetDet.site_address ? ` — ${assetDet.site_address}` : ''}
                                    </>
                                ) : null}
                                {assetDet && assetDet.site_ref && taskDet && taskDet.category_str ? ' · ' : ''}
                                {taskDet && taskDet.category_str ? taskDet.category_str : ''}
                            </span>
                        ) : null
                    }
                    actions={
                        <div className="task-header-actions">
                            <Button
                                variant="primary"
                                size="sm"
                                className="task-action-btn"
                                onClick={() => { props.history.push("/task_add/" + props.match.params.id); }}
                            >
                                <FaPencilAlt /> {t('actions.editTask')}
                            </Button>
                            <TaskPDF asset={assetDet} task={taskDet} users={usersDet} />
                            {isAdmin && isActiveTask && (
                                <Button
                                    variant="outline-secondary"
                                    size="sm"
                                    className="task-action-btn"
                                    onClick={handleShowMoveToCompleted}
                                >
                                    <FaCheck /> {t('actions.complete')}
                                </Button>
                            )}
                            {taskDet && taskDet.task_status === 'Completed' && (
                                <Button
                                    variant="outline-secondary"
                                    size="sm"
                                    className="task-action-btn"
                                    onClick={handleShowMoveToWip}
                                >
                                    <FaUndo /> {t('actions.moveToWip')}
                                </Button>
                            )}
                            <span className="task-action-split" aria-hidden="true" />
                            <Button
                                variant="outline-danger"
                                size="sm"
                                className="task-action-btn task-action-delete"
                                onClick={handleShow}
                            >
                                <FaTimes /> {t('actions.delete')}
                            </Button>
                        </div>
                    }
                />
                <div className="task-summary">
                    <div className="task-summary-item">
                        <span>{t('assets.priority')}</span>
                        <strong>{assetDet && assetDet.hp_site_str ? assetDet.hp_site_str : '—'}</strong>
                    </div>
                    <div className="task-summary-item">
                        <span>{t('common.classification')}</span>
                        <strong>{taskDet && taskDet.urgent_fault ? taskDet.urgent_fault : '—'}</strong>
                    </div>
                    <div className="task-summary-item">
                        <span>{t('tasks.slaAttend')}</span>
                        <strong>{taskDet && taskDet.sla_attend_str ? taskDet.sla_attend_str : '—'}</strong>
                    </div>
                    <div className="task-summary-item">
                        <span>{t('fields.slaComplete')}</span>
                        <strong>{taskDet && taskDet.sla_repair_str ? taskDet.sla_repair_str : '—'}</strong>
                    </div>
                </div>
                <div className="row div-content">
                    <div className="col-md-8">
                        <TaskInfo key="tabInfo" asset={assetDet} task={taskDet} loadedTask={loadedTaskDet} users={usersDet}
                            taskId={props.match.params.id} {...props} />  
                    </div>
                    <div className="col-md-4 p-0 m-0"> 
                        <TaskLog key="log" asset={assetDet} users={usersDet}
                            taskId={props.match.params.id}  />     
                    </div>                
                </div>  
                <Modal className="text-dark border-danger" show={show} onHide={handleClose} animation={false} >
                    <Modal.Header className="bg-danger text-light align-content-center" closeButton>
                    <Modal.Title><h4><strong>{t('taskView.deleteTitle')}</strong></h4></Modal.Title>
                    </Modal.Header>
                    <Modal.Body>{t('taskView.deleteConfirm')}</Modal.Body>
                    <Modal.Footer>
                    <Button className="m-0 mr-2" variant="danger" onClick={() => {handleDelete(props.match.params.id)}}>
                        {t('actions.delete')}
                    </Button>
                    <Button className="m-0"  variant="secondary" onClick={handleClose}>
                        {t('common.close')}
                    </Button>
                    </Modal.Footer>
                </Modal>

                <Modal className="text-dark border-warning" show={showWipModal} onHide={handleCloseWipModal} animation={false} >
                    <Modal.Header className="bg-warning text-dark align-content-center" closeButton>
                    <Modal.Title><h4><strong>{t('taskView.wipTitle')}</strong></h4></Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p>{t('taskView.wipHint')}</p>
                        <Form>
                            <Form.Group>
                                <Form.Control
                                    as="textarea"
                                    rows={4}
                                    placeholder={t('taskView.wipPlaceholder')}
                                    value={wipReason}
                                    onChange={(e) => setWipReason(e.target.value)}
                                    required
                                />
                            </Form.Group>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                    <Button className="m-0 mr-2" variant="warning" onClick={handleMoveToWip}>
                        {t('actions.moveToWip')}
                    </Button>
                    <Button className="m-0"  variant="secondary" onClick={handleCloseWipModal}>
                        {t('common.cancel')}
                    </Button>
                    </Modal.Footer>
                </Modal>

                <Modal className="text-dark border-primary" show={showCompleteModal} onHide={handleCloseCompleteModal} animation={false} >
                    <Modal.Header className="bg-primary text-light align-content-center" closeButton>
                    <Modal.Title><h4><strong>{t('taskView.completeTitle')}</strong></h4></Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p>{t('taskView.completeHint')}</p>
                        <Form>
                            <Form.Group>
                                <Form.Control
                                    as="textarea"
                                    rows={4}
                                    placeholder={t('taskView.completePlaceholder')}
                                    value={completeWorkDone}
                                    onChange={(e) => setCompleteWorkDone(e.target.value)}
                                    required
                                />
                            </Form.Group>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                    <Button className="m-0 mr-2" variant="primary" onClick={handleMoveToCompleted} disabled={completing}>
                        {completing ? t('actions.completing') : t('actions.moveToCompleted')}
                    </Button>
                    <Button className="m-0" variant="secondary" onClick={handleCloseCompleteModal} disabled={completing}>
                        {t('common.cancel')}
                    </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }

const mapStateToProps = state => {
    return {
        user: state.auth.user,
    };
};

export default connect(mapStateToProps)(TaskDetail);
